// src/views/EstadosFlujos/Tipos de estado/EditarTipoEstado.jsx
import React, { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EditarTipoEstado({ id, onClose, onVolver, onSaved }) {
  const closeFn = onClose || onVolver || (() => {});
  const savedFn = onSaved || (() => {});

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && closeFn();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [closeFn]);

  // ===== ESTADO DEL FORM =====
  const [nombre, setNombre] = useState("");
  const [cargando, setCargando] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // ===== CARGAR DATOS DESDE BACKEND =====
  useEffect(() => {
    if (!id) return;

    const load = async () => {
      try {
        setCargando(true);
        const url = apiRoutes.estadoTipo.detail(id);
        const json = await appFetchJson(url);

        // Backend devuelve: { id, nombre }
        setNombre(json.nombre ?? "");
      } catch (e) {
        setError("No se pudo cargar el tipo de estado.");
      } finally {
        setCargando(false);
      }
    };

    load();
  }, [id]);

  // Detectar si hubo cambios
  const changed = nombre.trim() !== "";

  // ===== GUARDAR =====
  const handleSave = async () => {
    if (!id || saving) return;

    setSaving(true);
    setError("");

    try {
      const body = {
        id,
        nombreTipoestado: nombre.trim(),
      };

      const url = apiRoutes.estadoTipo.update(id);

      // appFetchJson YA lanza error si falla.
      const data = await appFetchJson(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      savedFn();
      closeFn();
    } catch (e) {
      setError(e?.message || "Error al guardar.");
    } finally {
      setSaving(false);
    }
  };

  // ===== LOADING =====
  if (cargando) {
    return (
      <div className="modal-backdrop" onClick={closeFn}>
        <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
          <div className="modal-body">
            <h2 className="section-title mb-4">Editar Tipo de Estado</h2>
            <p>Cargando datos...</p>
          </div>
        </div>
      </div>
    );
  }

  // ===== FORMULARIO =====
  return (
    <div className="modal-backdrop" onClick={closeFn}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="section-title">Editar Tipo de Estado</h2>
        </div>

        <div className="modal-body">
          {error && <div className="mb-3 text-red-600">{error}</div>}

          <div className="form-grid">
            <FilaEdit
              label="Tipo de estado:"
              input={
                <input
                  type="text"
                  className="input"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              }
            />
          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            <button
              type="button"
              className="btn-fil disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={handleSave}
              disabled={!changed || saving}
            >
              <FaSave />
              {saving ? " Guardando…" : " Guardar"}
            </button>

            <button type="button" className="btn-fil" onClick={closeFn}>
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ==== Subcomponentes ==== */
function FilaEdit({ label, input }) {
  return (
    <div className="form-row gap-2 items-start">
      <div className="form-label">{label}:</div>
      <div className="flex-1">{input}</div>
    </div>
  );
}
